import { Flex } from '@libs/ui/ds'
import { Controller } from '@libs/ui/form'
import { useComponentsTranslation } from '@libs/utils/translations'
import { DpaeSSRFieldLabel } from '@spa/components'
import type { ContractFormType } from '@spa/scenes/MemberPage/modals/ContractInfoFormModal/types'
import type { FC } from 'react'
import { useFormContext } from 'react-hook-form'

import type { NewUserFormType } from '../FormNewUser/hooks/useNewUserForm'

type Props = {
  disabled?: boolean
}

export const InterimAdditionalFields: FC<Props> = ({ disabled = false }) => {
  const { t } = useComponentsTranslation()
  const { control, watch } = useFormContext<
    ContractFormType | NewUserFormType
  >()

  const isInterim = watch('contract_type') === 'interim'

  if (!isInterim) {
    return null
  }

  return (
    <Flex className='mb-5 gap-5 rounded bg-neutral-200 p-3'>
      <Controller.TextInput
        control={control}
        disabled={disabled}
        name='temp_agency_name'
        label={
          <DpaeSSRFieldLabel
            label={t('components.interimAdditional.nameLabel')}
            nameInput='temp_agency_name'
            disabled={disabled}
          />
        }
        placeholder={t('components.interimAdditional.namePlaceholder')}
      />
      <Controller.TextInput
        control={control}
        name='temp_agency_address'
        disabled={disabled}
        label={
          <DpaeSSRFieldLabel
            label={t('components.interimAdditional.adressLabel')}
            nameInput='temp_agency_address'
            disabled={disabled}
          />
        }
        placeholder={t('components.interimAdditional.adressPlaceholder')}
      />
      <Controller.TextInput
        control={control}
        name='temp_agency_zip'
        disabled={disabled}
        label={
          <DpaeSSRFieldLabel
            label={t('components.interimAdditional.zipLabel')}
            nameInput='temp_agency_zip'
            disabled={disabled}
          />
        }
        placeholder={t('components.interimAdditional.zipPlaceholder')}
      />
      <Controller.TextInput
        control={control}
        name='temp_agency_city'
        disabled={disabled}
        label={
          <DpaeSSRFieldLabel
            label={t('components.interimAdditional.cityLabel')}
            nameInput='temp_agency_city'
            disabled={disabled}
          />
        }
        placeholder={t('components.interimAdditional.cityPlaceholder')}
      />
    </Flex>
  )
}
